import { ButtonPermissionMap } from '../../constant/ButtonPermission'
export default {
  name: 'login_history',
  path: 'login_history',
  meta: {
    permission: ButtonPermissionMap.LoginHistory
  },
  component: () => import(/* webpackChunkName: "loginHistory" */ './list.vue')
}
